import { render } from "./ydFromItem.vue?vue&type=template&id=63fd94b4"
import script from "./ydFromItem.vue?vue&type=script&lang=js"
export * from "./ydFromItem.vue?vue&type=script&lang=js"

import "./ydFromItem.vue?vue&type=style&index=0&id=63fd94b4&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__